import { useAuth } from './state/AuthContext'
import { UiProvider } from './state/UiContext'
import { Login } from './routes/Login'
import { AgentApp } from './routes/AgentApp'

export function App() {
  const { user, loading } = useAuth()

  if (loading) return null
  if (!user) return <Login />

  return (
    <UiProvider>
      <AgentApp />
    </UiProvider>
  )
}
